import React from 'react'
import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { useGetResearchCompetitorsChartQuery } from '../../../../app/api'
import { IResearchFilter } from '../../model/types/ResearchFilter.interface'
import { selectResearchFilters } from '../../model/researchSlice'
import { changeCompetitorsDateRange, selectCompetitorsFilter } from '../../model/competitorsSlice'
import { ICompetitorsFilter } from '../../model/types/CompetitorsFilter.interface'
import { useDispatch } from 'react-redux'
import { GraphReport } from '../../../../shared/components/cards/graph-report/GraphReport'
import { useTranslation } from 'react-i18next'

export const CompetitorsByVisibility = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { country, project } = useAppSelector<IResearchFilter>(selectResearchFilters)
  const { sites, dateRange: filter } = useAppSelector<ICompetitorsFilter>(selectCompetitorsFilter)
  const { date, group: date_group } = filter

  const { data } = useGetResearchCompetitorsChartQuery(
    {
      body: {
        date_group,
        date,
        chart_site_ids: sites as unknown as number[],
        project_ids: (project ? [project] : []) as unknown as number[],
        country_ids: (country ? country : []) as unknown as number[],
      },
    },
    { skip: sites === undefined || !sites.length },
  )

  return (
    <GraphReport
      filter={filter}
      name={t('pages.advertisingResearch.advertisersByAds')}
      series={data}
      title={t('pages.advertisingResearch.advertisersByAds')}
      onChange={(e) => dispatch(changeCompetitorsDateRange(e))}
    />
  )
}
